/**
 * PrepItemCountRow — renders a single prep item's counting UI in inventory.
 * Used for both area-assigned prep items and unassigned prep items.
 */
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function PrepItemCountRow({
  prep, idx, quantity,
  onIncrement, onDecrement, onChange
}) {
  const qty = quantity || 0;
  return (
    <div
      data-testid={`prep-row-${prep.prep_id}`}
      className="p-4 bg-secondary/10 rounded-lg border border-secondary/20"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-xs text-muted-foreground font-mono">P{idx + 1}</span>
            <p className="font-medium">{prep.name}</p>
            <Badge variant="secondary" className="text-[10px]">PREP</Badge>
            <span className="text-xs bg-secondary/20 text-secondary-foreground px-2 py-0.5 rounded">
              ${prep.cost_per_unit?.toFixed(2)}/pan
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Yields {prep.yield_quantity} {prep.yield_unit} &bull; ${prep.total_cost?.toFixed(2)} total
          </p>
        </div>

        {qty > 0 && (
          <div className="text-right">
            <p className="text-lg font-semibold tabular-nums text-secondary">
              ${(qty * prep.cost_per_unit).toFixed(2)}
            </p>
            <p className="text-xs text-muted-foreground">value</p>
          </div>
        )}
      </div>

      <div className="flex flex-col max-w-xs">
        <Label className="text-xs text-muted-foreground mb-1">Pans / Batches</Label>
        <div className="flex items-center gap-1">
          <Button variant="outline" size="icon" className="h-12 w-12 shrink-0" onClick={() => onDecrement(prep.prep_id)}>-</Button>
          <Input
            type="number"
            value={qty || ""}
            onChange={(e) => onChange(prep.prep_id, e.target.value)}
            className="text-center h-12 text-lg tabular-nums"
            placeholder="0"
            min="0"
            step="1"
          />
          <Button variant="outline" size="icon" className="h-12 w-12 shrink-0" onClick={() => onIncrement(prep.prep_id)}>+</Button>
        </div>
      </div>
    </div>
  );
}
